import React from "react";
import { InvoicesDataTable } from "./";

const InvoicesPage = () => {
  return (
    <div className="sub-content">
      <InvoicesDataTable />
    </div>
  );
};

export default InvoicesPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/InvoicesPage.js